<template>
  <div>
    <no-data v-if="!sectionList.length && dataLoadState"></no-data>
    <div v-if="this.notiFicationShow === true && statusTab !=='COMPLETION'" class="notification-header shadow-bottom ">

      <div class="container container--narrow pdt-16 pdb-16">
        <div class="d-flex align-items-center pdb-8"><span class="notification-icon min-w-36 min-h-36"><i
            class="material-icons t-color-secondaryBtnText">notifications</i></span>
          <div class="t-body3 font-r l-spacing42 pdl-16">
            {{$t('143', {str: nextLessonName})}}
          </div>
        </div>
        <div class="d-flex justify-content-end">
          <button class="mdc-button  t-color-secondaryBtnText" tabindex="0" @click="learnLesson(nextLessonData)" @keypress="learnLesson(nextLessonData)">
            <div class="mdc-button__ripple"></div>
            <span class="mdc-button__label t-body3">
            {{$t('144')}}
          </span>
          </button></div>
      </div>
    </div>

    <div v-for="(course, index) in lessonData" :key="index" :class="{'pdb-30': index === course.length-1}" class="container container--narrow pdt-24">
      <div v-if="course.sections.length > 0" :class="{'pdb-30': index === course.length-1}" class="mdc-card pdb-8">
        <div class="t-headline7 font-m  mgb-16 mgr-12 pdt-24 pdl-24">{{ course.name }}</div>
        <div v-for="(section, index) in course.sections" :key="index" class="outer">
          <div class="t-body1 mgt-4 font-m pdr-24 pdl-24 l-spacing48 ">
            {{ section.name }}
          </div>
          <!-- <div v-if="section.lessons.length <= 0" class="d-flex pdt-16 pdb-16 mgl-24 my-course-list position-relative">
            <div class="list-image-small40">
              <img src="@/images/icon/study-disabled.svg" />
            </div>
            <div class="flex-grow-1 pdl-20">
              <div class="mgb-16 min-h-72">
                <div class="t-body1 mgb-4 font-r pdr-24 l-spacing48">
                  {{ $t('30203', {str: section.name }) }}
                </div>
                <div class="t-body6  font-r pdr-24 l-spacing45 t-color-bodyGrayA">
                  {{ $t('30204' )}}
                </div>
              </div>
            </div>
          </div> -->
          <div v-if="section.lessons.length <= 0" class="d-flex pdt-16 pdb-16 mgl-24 my-course-list position-relative min-h-auto">
            <div class="list-image-small40">
              <img src="@/images/icon/study-disabled.svg" />
            </div>
            <div class="flex-grow-1 pdl-20">
              <div class=" ">
                <div class="t-body1 mgb-4 font-r pdr-24 l-spacing48">
                  {{ $t('30203', {str: section.name }) }}
                </div>
                <div class="t-body6  font-r pdr-24 l-spacing45 t-color-bodyGrayA">
                  {{ $t('30204' )}}
                </div>
              </div>
            </div>
          </div>
          <div v-else>
            <div v-for="(lesson, index) in section.lessons" :key="index" :class="[statusTab === 'WAITING'?'':'cursor-pointer', index === section.lessons.length - 1 ? 'last': '']"
                 class="d-flex pdt-12 pdl-24 my-course-list position-relative" tabindex="0" @click.prevent="learnLesson(lesson)" @keypress.prevent="learnLesson(lesson)">
              <div class="list-image-small40">
                <img v-if="lesson.resourceType.value === 'EXAM'" src="@/images/icon/test.svg" />
                <img v-else-if="lesson.resourceType.value === 'LIVE_SESSION'" src="@/images/icon/live_sesson.svg"  />
                <img v-else src="@/images/icon/study.svg"  />

                <div v-if="statusTab !== 'WAITING'" class="h-2 position-relative total-percentage-course mgt-8 mgb-4 bg-iconinactiveText">
                  <div v-if="lesson && lesson.rate" :style="`width:${lesson.rate}%;`" class="real-percentage bg-bodyBlueGray h-2 "></div>
                  <!-- <div v-else-if="lesson.contentsType.value==='LIVE_SESSION' && liveProgressRate" class="real-percentage bg-bodyBlueGray h-2 " :style="`width:${liveProgressRate}%;`"></div> -->
                </div>
                <div v-if="lesson && lesson.rate && statusTab !== 'WAITING'"  class="t-body3 t-color-bodyBlueGray t-center font-r">{{parseInt(lesson.rate)}}%</div>
                <div v-else-if="statusTab !== 'WAITING'"  class="t-body3 t-color-bodyBlueGray t-center font-r">0%</div>
                <!-- <div v-else-if="lesson.contentsType.value==='LIVE_SESSION' && liveProgressRate" class="t-body3 t-color-bodyBlueGray t-center font-r">{{parseInt(liveProgressRate)}}%</div> -->
              </div>
              <div class="flex-grow-1 pdl-20">
                <div class="mgb-16 min-h-72">
                  <div class="t-body1 mgb-4 font-r pdr-24 l-spacing48">
                    {{lesson.name}}
                  </div>
                  <div v-if="lesson.contents.lcms" class="t-body6  font-r pdr-24 l-spacing45 t-color-bodyGrayA">
                    <div v-if="lesson.contents.lcms.type.translate === 'code.fileContentsType.InteractiveHTML' && lesson.resourceType && (lesson.resourceType.translate !== 'code.lessonResourceType.computerScience')">{{ $t('3166') }} </div>
                    <div v-else-if="lesson.contents.lcms.type.translate === 'code.fileContentsType.cegos' && lesson.resourceType && (lesson.resourceType.translate !== 'code.lessonResourceType.computerScience')">{{ $t('4828') }} </div>
                    <div v-else-if="lesson.contents.lcms.type.translate === 'code.fileContentsType.InteractiveHTML' && lesson.resourceType && (lesson.resourceType.translate === 'code.lessonResourceType.computerScience')" class="d-flex">{{ $t('3735') }} <div class="rightDivider"></div> {{ $t('3737') }}</div>
                    <div v-else-if="lesson.contents.lcms.type.translate === 'code.fileContentsType.liveSession'">{{ $t('3305') }} </div>
                    <div v-else-if="lesson.contents.lcms.type.translate === 'code.fileContentsType.video' && lesson.resourceType && (lesson.resourceType.translate !== 'code.lessonResourceType.computerScience')">{{ $t('100') }} </div>
                    <div v-else-if="lesson.contents.lcms.type.translate === 'code.fileContentsType.video' && lesson.resourceType && (lesson.resourceType.translate === 'code.lessonResourceType.computerScience')" class="d-flex">{{ $t('3735') }} <div class="rightDivider"></div> {{ $t('3736') }}</div>
                    <div v-else-if="lesson.contents.lcms.type.translate === 'code.fileContentsType.lcms'">{{ $t('100') }} </div>
                    <div v-else-if="lesson.contents.lcms.type.translate === 'code.fileContentsType.slide'">{{ $t('101') }} </div>
                    <div v-else-if="lesson.contents.lcms.type.translate === 'code.fileContentsType.pdf'">{{ $t('102') }} </div>
                    <div v-else-if="lesson.contents.lcms.type.translate === 'code.fileContentsType.html'">{{ $t('103') }} </div>
                    <div v-else-if="lesson.contents.lcms.type.translate === 'code.fileContentsType.exam'">{{ $t('148') }} </div>
                    <div v-else>{{ $t(lesson.contents.lcms.type.text) }}</div>
                  </div>
                  <div v-else class="t-body6  font-r pdr-24 l-spacing45 t-color-bodyGrayA">
                    <div>{{ $t(lesson.resourceType.text) }}</div>
                  </div>

                  <div v-if="lesson.contents.meeting && lesson.contents.meeting.timezone" class="mgt-3">
                    <div class=" d-flex align-items-baseline">
                      <div class="t-body6  font-r pdr-6 l-spacing45 t-color-bodyGrayA">
                        {{lesson.contents.meeting.timezone_code.text}}
                      </div>
                      <div class="t-body6  font-r pdr-24 l-spacing45 t-color-bodyGrayA mgt-3" v-html="convertTimeZone(lesson.contents.meeting.start_time, lesson.contents.meeting.timezone_code.key)">
                      </div>
                    </div>
                    <div class="mgt-4 d-flex">
                      <!-- <div class="t-body6  font-r pdr-24 l-spacing45 t-color-bodyGrayA">{{$t('3308',{'str1':year,'str2':month,'str3':day})}}: </div> -->
                      <div class="t-body6  font-r pdr-24 l-spacing45 t-color-bodyGrayA" v-html="convertTDuration(lesson.contents.meeting.duration)"></div>
                    </div>
                  </div>

                </div>
              </div>
              <div v-if="lesson.learningMaterials.length > 0 && statusTab !== 'WAITING'" class="pdr-24"><i
                  class="material-icons t-color-iconInactiveText cursor-pointer"
                  tabindex="0" @click.stop="donwloadFile(lesson.learningMaterials[0])">download</i>
              </div>
            </div>
            <div :class="{'d-none': index === course.sections.length-1}" class="mgt-24 mgb-24"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/**
 * 나의 학습 상세 - 레슨 컴포넌트(my learning view - lesson component)
 *
 * @author minkyoung.park@emcast.com
 */

// Components/Mixin/Extend/API define
import { MDCRipple } from "@material/ripple";
import { fileMixin } from "@/mixins/file.js";
import NoData from "../../common/NoDataLesson.vue";
import microLearnApi from "@/api/microLearnApi";

export default {
  components: {
    "no-data": NoData,
  },

  props:['basicData', 'todayDate', 'lessonsList', 'sectionList', 'lessonData', 'dataLoadState', 'nextLessonName', 'nextLessonData', 'notiFicationProgressRate', 'notiFicationShow'],

  data() {
    return {
      liveProgressRate: 0,
      progressionId: 0,
      statusTab: null
    };
  },

  mixins: [fileMixin],

  watch:{
    '$route' (to, from){
      let getExamResult = this.$route.query.examresult;
      if(getExamResult === 'getscore') {
        this.fetchData();
      }
    },
  },

  computed: {

  },

  mounted() {
    this.statusTab = this.$route.query.status;
    document.body.classList.remove('contentDarkMode');
  },

  updated() {
    const ripples = [].map.call(
        document.querySelectorAll(".ripple-item"),
        function (el) {
          let ripple = new MDCRipple.attachTo(el);
          return ripple;
        }
    );
  },

  methods: {
    // 파라미터 설정(set parameter)
    setParams() {
      const params = {
        learnId: this.$route.params.learnId,
      };
      return params;
    },

    // learn lesson
    learnLesson(lesson) {
      if (lesson.status.value === "OPENED") {
        if (lesson.resourceType && lesson.resourceType.value === "EXAM") {
          let query = this.$route.query;
          query.type = 'formal-evolution'
          this.$router.push({
            name: "MicroExamIntro",
            params: {
              learnId: this.$route.params.learnId,
              examineeId: lesson.examineeId,
            },
            query: query,
          });
        } else if(lesson.resourceType && lesson.resourceType.value === 'LIVE_SESSION') {
          let params = {
            learnId: this.$route.params.learnId,
            progressionId: lesson.progressionId
          }
          microLearnApi.learnLessonContents(params).then((response) => {
            let liveSessionTrueFalse = response.data.data.liveSession.canParticipate;
            if(liveSessionTrueFalse === false) {
              this.$alert({
                title: this.$t("3434"), // "3434": "라이브 세션 진행 시간이 아닙니다.",
                content: this.$t("3435"),
                accept: this.$t("3436"),
              }).then(() => {})
                  .catch(() => {});
            } else {
              let responseData = response.data.data
              let liveSessionData = responseData
              this.zoomMetting(lesson,liveSessionData)
            }
          }).catch((err) => {
          })
        } else if(this.statusTab === 'COMPLETION') {
          if(this.todayDate < this.basicData.periodReview.end && this.todayDate > this.basicData.periodReview.start) {
              this.$router.push({
                name: "MicroDegreeLessonView",
                params: {
                  learnId: this.$route.params.learnId,
                  lessonId: lesson.id,
                  progressionId: lesson.progressionId,
                },
                query: this.$route.query,
              });
            } else {
              this.$alert({
                title: this.$t("1944"), // "1944": "학습 또는 복습 기간이 아닙니다.",
                content: this.$t("1945"),
                accept: this.$t("1946"),
              }).then(() => {}).catch(() => {});
            }
          } else {
          this.$router.push({
            name: "MicroDegreeLessonView",
            params: {
              learnId: this.$route.params.learnId,
              lessonId: lesson.id,
              progressionId: lesson.progressionId,
            },
            query: this.$route.query,
          });
        }
      } else if(this.statusTab === "WAITING" || lesson.status.value === "WAITING") {
        if(this.todayDate < this.basicData.periodLearning.start) {
          this.$alert({
            title: this.$t("3431"), // "3431": "학습 또는 복습 기간 전입니다.",
            content: this.$t("3432"),
            accept: this.$t("3433"),
          }).then(() => {}).catch(() => {});
        } else if(this.todayDate > this.basicData.periodReview.end) {
          this.$router.push({
            name: "MicroDegreeLessonView",
            params: {
              learnId: this.$route.params.learnId,
              lessonId: lesson.id,
              progressionId: lesson.progressionId,
            },
            query: this.$route.query,
          });
        } else {
          this.$alert({
            content: this.$t("1885") + " " + this.$t("1886"), // "1885": "이 강의는 레슨을 순서대로 학습해야 합니다.",
            accept: this.$t("1887"),
          }).then(() => {});
        }
      } else {
        this.$alert({
          content: this.$t("1885") + " " + this.$t("1886"), // "1885": "이 강의는 레슨을 순서대로 학습해야 합니다.",
          accept: this.$t("1887"),
        }).then(() => {});
      }
    },

    zoomMetting(lesson,liveSessionData,target='_blank', rel="noopener noreferrer") {
      window.open(liveSessionData.liveSession.url, target,rel);
      this.updateProgress(lesson)
    },

    updateProgress(lesson) {
      let params = {
        total: 0,
        current: 0,
        learnId: this.$route.params.learnId,
        progressionId: lesson.progressionId
      }
      let responseData = null
      microLearnApi.learnLessonProgression(params).then((response) => {
        responseData = response.data.data
        this.liveProgressRate = responseData.rate
        this.$router.go(this.$router.currentRoute)
      }).catch((err) => {})
    },

    convertTimeZone(time, zone) {
      return this.$moment(time).format('L') +' '+ this.$moment(time).format('LT');
    },

    convertTDuration(duration) {
      let h = Math.floor(duration / 60);
      let m = duration % 60;
      h = h < 10 ? h : h;
      m = m < 10 ? m : m;
      return this.$t('3308',{'str1':`${h}`,'str2':`${m}`});
    }
  },
};
</script>

<style scoped>
.material-icons.orange600 {
  color: var(--Secondary);
}
.lesson-fixed-button{
  position: fixed;
  bottom: 30px;
  right: 0px;
}
</style>
